import Leaflet from "leaflet";
import carPin from "../../../images/mapPins/carPin.svg";
import motorPin from "../../../images/mapPins/motorMapIcon2.png";

const customIcon = (param, icon, driver) => {
    return Leaflet.divIcon({
        className: "marker",
        html: `
        <div>
            <img src=${icon} alt="mapIcon" class="markerIcon">
            <p class="carPinAdornment">${param}${driver ? `<br/><span class="carPinDriver">${driver}</span>` : ''}</p>
        </div>
        `
    });
};

export default (type, registrationNo, driver) => type === "Motocykl" ? customIcon(registrationNo, motorPin, driver) : customIcon(registrationNo, carPin, driver);